<template>
  <div id="app">
    <template v-cloak>
      <PersonalNav v-if="isRouterAlive && showNavNFooter"/>
      <TypeNav :obj="TypeRoute" v-if="showNavNFooter"/>
    </template>
    <template v-cloak>
<!--      <Instruction/>-->
<!--      <el-tooltip class="item" effect="dark" content="点击下载操作手册" placement="left">-->
<!--        <button class="commonBtn btn-shadow sideFixedBtn step"-->
<!--                @click="downloadFile('http://mtc.bgrimm.cn:42900/yshop/北矿检测在线商城下单操作步骤.pdf')">-->
<!--          <span>下单<br>步骤</span>-->
<!--          <a href="http://mtc.bgrimm.cn:42900/yshop/北矿检测在线商城下单操作步骤.pdf">hahaha</a>-->
<!--        </button>-->
<!--      </el-tooltip>-->
<!--      <el-tooltip class="item" effect="dark" content="点击下载申请单" placement="left">-->
<!--        <button class="commonBtn btn-shadow sideFixedBtn apply"-->
<!--                @click="downloadFile('http://mtc.bgrimm.cn:42900/yshop/北矿检测在线商城账号开通申请单.docx')">-->
<!--          <span>账号<br>开通<br>申请单</span>-->
<!--        </button>-->
<!--      </el-tooltip>-->
      <el-tooltip class="item" effect="dark" content="点击下载操作手册" placement="left">
        <button class="commonBtn btn-shadow sideFixedBtn step">
          <a href="http://mtc.bgrimm.cn:42900/yshop/北矿检测在线商城下单操作步骤.pdf"
             download
             target="_blank">
            下单<br>步骤
          </a>
        </button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="点击下载申请单" placement="left">
        <button class="commonBtn btn-shadow sideFixedBtn apply">
          <a href="http://mtc.bgrimm.cn:42900/yshop/北矿检测在线商城账号开通申请单.docx"
             download
             target="_blank">
            账号<br>开通<br>申请单
          </a>
        </button>
      </el-tooltip>
    </template>
    <router-view/>
    <template v-cloak>
      <VFoot :obj="FooterData" v-if="showNavNFooter"/>
    </template>
  </div>
</template>

<script>
// components
import VHeader from '@/components/base/v-header'
import VFoot from '@/components/base/v-foot2'
import PersonalNav from '@/components/common/TopPersonalNav2'
import TypeNav from '@/components/common/TopTypeNav'
import Instruction from '@/components/common/instruction'
// api
import {
  getCanvasData
} from '@/api/indexpage.js'
// moc data
import { mocNavType } from '@/mocData/topTypeNav.js'
import axios from "axios";
export default {
  name: 'App',
  components: {VHeader, VFoot, PersonalNav, TypeNav, Instruction},
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      TypeRoute: {},
      FooterData: {},
      fullScreen: ['/orderPrint', '/viewReport', '/download']
    }
  },
  computed: {
    showNavNFooter() {
      const path = this.$route.path;
      // 路径：不为'/'且不包含于全屏显示数组中时，显示页眉和页脚
      return path !== '/' && !this.fullScreen.includes(path);
    }
  },
  watch: {
    $route (to, from) {
      if (to.name !== from.name) {
        this.reload()
      }
    }
  },
  created () {
    // this.getCanvas();
  },
  mounted() {
    // 触发不稳定，暂不使用
    // noted: chrome60之后，未进行页面交互时不触发onbeforeunload
    // 在页面刷新时将vuex里的信息保存到localStorage里
    // window.addEventListener('beforeunload', () => {
    //   localStorage.setItem('messageStore', JSON.stringify(this.$store.state));
    // });
    // 在页面加载时读取localStorage里的状态信息
    // localStorage.getItem('messageStore') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('messageStore'))));
  },
  methods: {
    async getCanvas () {
      var res = await getCanvasData({ terminal: '4' })
      if (!res.json) {
        return
      }
      var canvasData = JSON.parse(res.json)
      canvasData = canvasData.map(item => {
        if (item.type === 'NavType') {
          return mocNavType
          // return item
        }
        if (item.type === 'Footer') {
          return item
        }
      }).filter(r => r)
      this.TypeRoute = this.giveTypeRes('NavType', canvasData)
      this.FooterData = this.giveTypeRes('Footer', canvasData)
    },
    giveTypeRes (type, data) {
      var result
      for (var key in data) {
        if (data[key].type === type) {
          result = data[key]
        }
      }
      return result
    },

    /*
     * 暂不使用
     * bkjc-下载说明文件
     */
    async downloadFile(url){
      try {
        const fileURL = await this.getFile(url);
        const fileName = decodeURIComponent(url.split('/').pop());  // 处理文件名中的特殊字符
        const a = document.createElement('a');
        a.href = fileURL;
        a.setAttribute('download', fileName);  // filename
        a.click();
        URL.revokeObjectURL(fileURL); // 释放内存
      } catch(err) {
        this.$message.error('下载失败');
      }
    },
    // 暂不使用：获取后端存储的文件
    getFile(url) {
      let _this = this;
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: url,
          responseType: 'blob'
        }).then(function(res) {
          if(res.status !== 200) {
            _this.$message.error('报告下载失败');
            reject && reject();
          }
          const contentType = res.headers['content-type']; // 获取响应的Content-Type
          let blob = new Blob([res.data], { type: contentType });
          let fileURL = URL.createObjectURL(blob);
          resolve && resolve(fileURL);
        }).catch(reject);
      });
    },

    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    }
  }
}
</script>
<style lang="scss">
[v-cloak] {
  display: none !important;
}

#app{
  min-width: 1440px;
  background-color: #F6F6F8;  /*v-header 背景颜色*/
}
.el-loading-mask{
  .el-loading-spinner{
    .path{
      stroke: #333333;
    }
  }
}
// loading
.el-loading-spinner{
  i,.el-loading-text{
    font-size: 18px;
    color: #333333;
  }
}

.pagination {
  padding: 30px 0;
  max-width: 1170px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

// “下单步骤”/“账号开通申请单”下载按钮
.sideFixedBtn{
  position: fixed;
  right: 3vw;
  /*width: 10vh;*/
  /*height: 10vh;*/
  width: 70px;
  height: 70px;
  z-index: 999;  // 最上层
  font-weight: bold;
  color: #fff;
  opacity: 0.8;
}
.step{
  top: 43vh;
  background-color: $mainColor;
  &:hover{
    cursor: pointer;
    background-color: $plainBtnSelectedColor;
    opacity: 1;
  }
  span{
    font-size: 18px;
  }
}
.apply{
  top: 57vh;
  background-color: $btnColor;
  &:hover{
    cursor: pointer;
    background-color: $btnSelectedColor;
    opacity: 1;
  }
  span{
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue